import React, { useState } from "react";
import { Button, ChevronDownIcon, ChevronEndIcon, Flex } from "@fluentui/react-northstar";
import { SegmentContent, Title } from "shared/components";

export interface ReportSectionProps {
    title?: string;
    filters: JSX.Element[];
    reportContent: React.ReactNode;
    isMobileView: boolean;
    isCollapsible?: boolean;
    highlightColor?: string;
}

export const ReportSection: React.FC<ReportSectionProps> = (props) => {
    const [isOpen, setIsOpen] = useState(props.isCollapsible ? false : true);

    return (
        <SegmentContent style={{ borderLeft: props.highlightColor ? `4px solid ${props.highlightColor}` : undefined }}>
            <Flex column fill gap="gap.small">
                <Flex
                    wrap
                    column={props.isMobileView}
                    space={props.isMobileView ? undefined : "between"}
                    vAlign="center">
                    <div style={props.isMobileView ? { paddingBottom: "8px" } : undefined}>
                        <Flex space="between" vAlign="center">
                            <Title isHeader text={props.title ?? ""} />

                            {props.isCollapsible && (
                                <div style={{ paddingLeft: "5px" }}>
                                    <Button
                                        iconOnly={true}
                                        icon={
                                            isOpen ? (
                                                <ChevronDownIcon size="medium" />
                                            ) : (
                                                <ChevronEndIcon size="medium" />
                                            )
                                        }
                                        onClick={() => {
                                            setIsOpen(!isOpen);
                                        }}
                                    />
                                </div>
                            )}
                        </Flex>
                    </div>
                    {isOpen && (
                        <Flex
                            wrap
                            column={props.isMobileView}
                            hAlign="end"
                            style={{alignContent: "flex-end", marginLeft: props.isMobileView ? undefined : "auto", border: ".25rem solid transparent", borderRight: "0"}}
                            gap="gap.small">
                            {props.filters}
                        </Flex>
                    )}
                </Flex>
                {isOpen && props.reportContent}
            </Flex>
        </SegmentContent>
    );
};
